/**
 * Имена рыб и приметы вида, вторая сотня: русский.
 *
 * ⚠️ ОТДЕЛЬНО ОТ ПЕРВОЙ СОТНИ, КАК И САМИ ДАННЫЕ. Первая сотня заняла 26 КБ;
 * вторая столько же, и вместе они подошли бы к пределу в 100 КБ вплотную —
 * а править словарь, который не читается целиком, значит править вслепую.
 * Деление то же, что у описаний видов: species-north-ru.ts — наша полоса,
 * этот файл — остальной мир.
 *
 * ⚠️ ИМЕНА БЕРУТСЯ ТЕ, ПОД КОТОРЫМИ РЫБУ ЗНАЮТ РУССКОЯЗЫЧНЫЕ РЫБОЛОВЫ, а не
 * буквальный перевод латыни. «Уоллай», «маскинонг», «барамунди», «арапайма»
 * вошли в язык как есть; переводить их «американским судаком» значило бы
 * запутать того, кто ищет знакомое слово.
 *
 * ⚠️ ПРИМЕТА ОТВЕЧАЕТ НА ТОТ ЖЕ ВОПРОС, ЧТО И В ПЕРВОЙ СОТНЕ: «я это поймал —
 * кто это?». Сперва то, что видно в руке, потом где стоит. Ни весов, ни
 * горизонтов: они есть числами, и два места об одном разойдутся.
 */
export const МИР_RU: Record<string, string> = {
  // ── Иберия и Италия ─────────────────────────────────────────────────────
  'fish.iberian_barbel': 'иберийский усач',
  'fish.iberian_barbel_look':
    'Вытянутый, оливково-бронзовый, с четырьмя усами и нижним ртом. Стоит в ямах под перекатами.',
  'fish.comizo_barbel': 'усач-комиза',
  'fish.comizo_barbel_look':
    'Усач с длинным рылом и почти щучьей пастью — единственный, кто бьёт малька. Держится в глубине.',
  'fish.gitano_barbel': 'южноиберийский усач',
  'fish.gitano_barbel_look':
    'Помельче и потемнее собратьев, бок в мелких пятнышках. Выходит стаей на прикормленную точку.',
  'fish.ebro_barbel': 'эбрский усач',
  'fish.ebro_barbel_look':
    'Плотный, золотисто-серый, с толстыми губами. Тянет по течению не хуже сазана вдвое тяжелее.',
  'fish.iberian_nase': 'иберийский подуст',
  'fish.iberian_nase_look':
    'Серебристый, с тёмной спиной и нижним поперечным ртом. Скоблит камни на струе стаей.',
  'fish.iberian_chub': 'южноиберийский голавль',
  'fish.iberian_chub_look':
    'Мельче нашего голавля, с крупной чешуёй и тёмной спинкой. Держится под нависшими кустами.',
  'fish.italian_barbel': 'итальянский усач',
  'fish.italian_barbel_look':
    'Прогонистый, с тёмной пятнистой спиной и четырьмя усами. Лежит на перекатах притоков По.',
  'fish.italian_chub': 'итальянский голавль',
  'fish.italian_chub_look':
    'Широколобый, серебристый, с тёмной каймой чешуи. Берёт поверху и бьётся у самых ног.',
  'fish.italian_roach': 'итальянская плотва',
  'fish.italian_roach_look':
    'Мелкая, серебряная, с жёлтым глазом. Стоит плотной стайкой в каналах Ломбардии.',
  'fish.italian_pike': 'итальянская щука',
  'fish.italian_pike_look':
    'Южная щука: бок в мелких светлых пятнах вместо жёлтых полос. Стоит в старицах и озёрах.',
  'fish.agone': 'агоне',
  'fish.agone_look':
    'Селёдка альпийских озёр: узкая, серебряная, с тёмным пятном за жаберной крышкой. Ходит стаей в толще.',

  // ── Балканы, Дунай и Междуречье ─────────────────────────────────────────
  'fish.danube_shad': 'дунайская сельдь',
  'fish.danube_shad_look':
    'Серебристая, с килем на брюхе и рядом тёмных пятен вдоль бока. Идёт вверх по Дунаю в апреле.',
  'fish.softmouth_trout': 'мягкорылая форель',
  'fish.softmouth_trout_look':
    'Форель карстовых рек с мягким выступающим рылом и мелким тёмным крапом. Стоит в прозрачной воде.',
  'fish.dentex_trout': 'зубатая форель',
  'fish.dentex_trout_look':
    'Хищная балканская форель с зубастой пастью и высоким телом. Бьёт уклейку у поверхности плёсов.',
  'fish.ohrid_trout': 'охридская форель',
  'fish.ohrid_trout_look':
    'Серебристая форель Охридского озера в редких чёрных точках. Держится на глубине круглый год.',
  'fish.schraetzer': 'дунайский ёрш',
  'fish.schraetzer_look':
    'Узкий полосатый ёрш с вытянутым рылом: вдоль бока идут тёмные линии. Лежит на дне русла.',
  'fish.greek_catfish': 'греческий сом',
  'fish.greek_catfish_look':
    'Сом рек Эпира: короче нашего, с широкой головой и двумя усами. Стоит в ямах под завалами.',
  'fish.tigris_barbel': 'тигровый усач',
  'fish.tigris_barbel_look':
    'Огромный усач Тигра и Евфрата с щучьим рылом. Караулит рыбёшку на дне глубоких плёсов.',
  'fish.shabut': 'шабут',
  'fish.shabut_look':
    'Высокотелый золотистый усач с толстыми губами и крупной чешуёй. Кормится на дне тёплых рек.',
  'fish.mesopotamian_catfish': 'месопотамский сом',
  'fish.mesopotamian_catfish_look':
    'Сом Тигра и Евфрата: тело светлее нашего, в мраморных разводах. Лежит в глубоких ямах.',

  // ── Западная и Северная Европа ──────────────────────────────────────────
  'fish.blaufelchen': 'блауфельхен',
  'fish.blaufelchen_look':
    'Сиг Боденского озера с синеватой спиной и мелким ртом. Стоит на большой глубине в толще.',
  'fish.alpine_char': 'альпийская палия',
  'fish.alpine_char_look':
    'Голец горных озёр: тёмная спина, розовые пятна, белая кайма нижних плавников. Любит ледяную глубину.',
  'fish.aquitanian_pike': 'аквитанская щука',
  'fish.aquitanian_pike_look':
    'Щука рек юго-запада Франции: мельче обыкновенной, бок в оливковых разводах. Стоит в засаде у травы.',
  'fish.danube_roach': 'дунайская плотва',
  'fish.danube_roach_look':
    'Крупная плотва с высоким телом и оранжевыми плавниками. Ходит стаей по руслу Дуная.',
  'fish.pearlfish': 'перлфиш',
  'fish.pearlfish_look':
    'Тяжёлая плотва предальпийских озёр; в нерест бок покрывается жемчужной сыпью. Стоит на глубине.',
  'fish.minnow': 'гольян',
  'fish.minnow_look':
    'Крошечный, пёстрый, с тёмными пятнами вдоль бока; в нерест брюшко алое. Держится в ручьях стайкой.',
  'fish.brook_lamprey': 'ручьевая минога',
  'fish.brook_lamprey_look':
    'Мелкая минога чистых ручьёв: змеевидная, без челюстей. Взрослой не кормится вовсе.',
  'fish.mediterranean_barbel': 'южный усач',
  'fish.mediterranean_barbel_look':
    'Небольшой усач с пятнистым боком и оранжевым хвостом. Стоит на каменистых перекатах.',
  'fish.apron': 'апрон',
  'fish.apron_look':
    'Длинный вальковатый окунёк Роны с тёмными перевязями. Прижимается ко дну на быстрине.',
  'fish.topmouth_gudgeon': 'амурский чебачок',
  'fish.topmouth_gudgeon_look':
    'Крошечный вселенец с верхним ртом и тёмной полосой вдоль бока. Заполоняет тихие пруды.',
  'fish.peipus_whitefish': 'чудской сиг',
  'fish.peipus_whitefish_look':
    'Сиг Чудского озера: серебристый, с прямым лбом и нижним ртом. Кормится у дна на песке.',

  // ── Восточная Европа, Кавказ, Средняя Азия и Сибирь ─────────────────────
  'fish.amur_redfin': 'амурский жерех',
  'fish.amur_redfin_look':
    'Прогонистый, серебряный, с плоской головой и малиновыми плавниками. Бьёт малька на струе.',
  'fish.mongolian_redfin': 'монгольский краснопёр',
  'fish.mongolian_redfin_look':
    'Хищник Амура с задранным ртом и красноватыми плавниками. Гоняет мелочь в толще проток.',
  'fish.balkhash_marinka': 'балхашская маринка',
  'fish.balkhash_marinka_look':
    'Тёмно-оливковая, вальковатая, с двумя парами усиков и нижним ртом. Кормится на каменистом дне.',
  'fish.common_marinka': 'маринка',
  'fish.common_marinka_look':
    'Серебристо-серая рыба горных рек с толстыми губами. Берёт на упавшее насекомое у самой струи.',
  'fish.naked_osman': 'голый осман',
  'fish.naked_osman_look':
    'Почти без чешуи, тёмно-бурый, с усиками у нижнего рта. Держится на камнях у берега Иссык-Куля.',
  'fish.altai_osman': 'алтайский осман',
  'fish.altai_osman_look':
    'Плотный, серо-зелёный, с крупной головой. В горных озёрах становится хищником и бьёт мелочь.',
  'fish.khramulya': 'храмуля',
  'fish.khramulya_look':
    'Тёмная спина, серебряный бок, нижний рот с роговой кромкой. Скоблит водоросли с камней.',
  'fish.bulatmai_barbel': 'булат-маи',
  'fish.bulatmai_barbel_look':
    'Крупный усач Куры и Аракса, золотисто-серый, с толстыми губами. Ходит по дну на течении.',
  'fish.pike_asp': 'лысач',
  'fish.pike_asp_look':
    'Щуковидный жерех Амударьи: вытянутый, серебряный, с плоской головой. Гоняет мелочь на разливах.',
  'fish.balkhash_perch': 'балхашский окунь',
  'fish.balkhash_perch_look':
    'Окунь без полос: ровно-серый, с колючим гребнем. Стоит у зарослей и коряг Балхаша.',
  'fish.baikal_grayling': 'чёрный байкальский хариус',
  'fish.baikal_grayling_look':
    'Тёмный, почти лиловый, с огромным парусным плавником в пятнах. Стоит на камнях у берега.',
  'fish.round_whitefish': 'валёк',
  'fish.round_whitefish_look':
    'Сиг с круглым в сечении телом и маленьким нижним ртом. Лежит на галечном дне северных рек.',
  'fish.humpback_whitefish': 'сиг-пыжьян',
  'fish.humpback_whitefish_look':
    'Горбатый сиг с приплюснутой головой и нижним ртом. Кормится на дне сибирских рек.',
  'fish.brown_bullhead': 'карликовый сомик',
  'fish.brown_bullhead_look':
    'Бурый сомик с квадратным хвостом и восемью усиками. Забивает мелкие пруды и берёт круглый год.',

  // ── Тихоокеанские лососи ────────────────────────────────────────────────
  'fish.chinook': 'чавыча',
  'fish.chinook_look':
    'Самый крупный тихоокеанский лосось: тёмная спина в чёрных точках, чёрные дёсны. Стоит в ямах.',
  'fish.coho': 'кижуч',
  'fish.coho_look':
    'Ярко-серебряный, с широким хвостом; в реке бок наливается малиновым. Держится на струе.',
  'fish.chum': 'кета',
  'fish.chum_look':
    'В реке покрывается лиловыми полосами поперёк тела, челюсти загибаются. Идёт руслом на нерест.',
  'fish.pink_salmon': 'горбуша',
  'fish.pink_salmon_look':
    'Мелкий лосось с крупными чёрными пятнами на хвосте; у самца в реке вырастает горб. Ходит массой.',
  'fish.masu': 'сима',
  'fish.masu_look':
    'Серебристый лосось с розовой полосой и тёмными пятнами. Единственный, кто живёт только в Азии.',
  'fish.sakhalin_taimen': 'сахалинский таймень',
  'fish.sakhalin_taimen_look':
    'Тёмная спина, красноватые плавники, широкая пасть. Стоит в устьях и низовьях сахалинских рек.',

  // ── Восточная Азия ──────────────────────────────────────────────────────
  'fish.herabuna': 'херабуна',
  'fish.herabuna_look':
    'Высокий плоский карась с длинным анальным плавником. Кормится в толще, а не со дна.',
  'fish.ugui': 'угай',
  'fish.ugui_look':
    'Японский елец: серебристый, в нерест с тремя оранжевыми полосами вдоль бока. Ходит стаей.',
  'fish.hasu': 'хасу',
  'fish.hasu_look':
    'Некрупный хищник с изогнутым ртом и синеватым отливом. Бьёт мелочь у поверхности озёр.',
  'fish.wuchang_bream': 'уханский лещ',
  'fish.wuchang_bream_look':
    'Короткий высокий лещ с прямой спиной и мелкой чешуёй. Держится в толще прудов и водохранилищ.',
  'fish.chinese_culter': 'китайский верхогляд',
  'fish.chinese_culter_look':
    'Плоский, серебряный, с задранным вверх ртом и прямой спиной. Гоняет малька поверху.',
  'fish.barbel_steed': 'конь-губарь',
  'fish.barbel_steed_look':
    'Прогонистый, с длинным рылом, толстой губой и парой усиков. Роется на песчаном дне.',
  'fish.amur_wels': 'амурский сом',
  'fish.amur_wels_look':
    'Мельче европейского, с четырьмя усами и пятнистым боком. Лежит в тихих протоках под корягами.',
  'fish.biwa_catfish': 'бивский сом',
  'fish.biwa_catfish_look':
    'Крупный сом озера Бива с широкой пастью и коротким телом. Выходит на отмели к ночи.',
  'fish.mandarin_fish': 'ауха',
  'fish.mandarin_fish_look':
    'Пятнистый окунь с колючим гребнем и мраморным боком. Стоит в засаде у дна среди камней.',
  'fish.leopard_mandarin': 'леопардовая ауха',
  'fish.leopard_mandarin_look':
    'Мельче обычной аухи, бок в круглых тёмных пятнах, как у леопарда. Держится в горных речках.',
  'fish.ayu': 'аю',
  'fish.ayu_look':
    'Стройная, прозрачно-зелёная, с жёлтым пятном на жаберной крышке; пахнет арбузом. Пасётся на камнях.',
  'fish.wakasagi': 'вакасаги',
  'fish.wakasagi_look':
    'Крошечная корюшка озёр Японии: полупрозрачная, с серебряной полосой. Стоит стаей в толще.',
  'fish.iwana': 'ивана',
  'fish.iwana_look':
    'Голец японских ручьёв: тёмная спина, белые точки, оранжевое брюшко. Стоит под камнями и корягами.',
  'fish.yamame': 'ямаме',
  'fish.yamame_look':
    'Речная форма симы: тёмные овальные пятна вдоль бока, красные точки. Живёт в холодных ручьях.',
  'fish.japanese_eel': 'японский угорь',
  'fish.japanese_eel_look':
    'Змеевидный, тёмно-серый, со светлым брюхом и мелкими жаберными щелями. Ночью выходит на отмели.',
  'fish.amur_sturgeon': 'амурский осётр',
  'fish.amur_sturgeon_look':
    'Осётр с острым рылом и рядами костяных жучек, темнее русского. Ходит по дну Амура.',

  // ── Северная Америка ────────────────────────────────────────────────────
  'fish.walleye': 'уоллай',
  'fish.walleye_look':
    'Судак Америки: мутно-белые глаза с отблеском, клыки, белый угол хвоста. Работает дно по бровкам.',
  'fish.yellow_perch': 'жёлтый окунь',
  'fish.yellow_perch_look':
    'Ярко-жёлтый, с семью тёмными полосами и оранжевыми брюшными. Держится плотной стаей.',
  'fish.muskellunge': 'маскинонг',
  'fish.muskellunge_look':
    'Огромная щука со светлым боком в тёмных полосах и раздвоенным хвостом. Стоит в засаде у травы.',
  'fish.black_crappie': 'чёрный краппи',
  'fish.black_crappie_look':
    'Высокий, серебристый, в чёрных крапинах без порядка. Висит стаей у затопленных деревьев.',
  'fish.bluegill': 'синежаберный солнечник',
  'fish.bluegill_look':
    'Круглый, пёстрый, с синим язычком на жаберной крышке. Толчётся у травы и берёт всё подряд.',
  'fish.blue_catfish': 'голубой сом',
  'fish.blue_catfish_look':
    'Серо-голубой, с прямым краем анального плавника и раздвоенным хвостом. Держит русло на течении.',
  'fish.flathead_catfish': 'плоскоголовый сом',
  'fish.flathead_catfish_look':
    'Приплюснутая голова, выступающая нижняя челюсть, жёлто-бурый бок. Караулит в завалах.',
  'fish.american_lake_trout': 'озёрная палия',
  'fish.american_lake_trout_look':
    'Крупный голец Великих озёр: тёмный, в светлых пятнах, хвост глубоко вырезан. Стоит на глубине.',
  'fish.brook_char': 'американская палия',
  'fish.brook_char_look':
    'Тёмная спина в мраморных разводах, красные точки в голубых ободках, белая кайма плавников.',
  'fish.striped_bass': 'полосатый лаврак',
  'fish.striped_bass_look':
    'Серебряный, с семью тёмными полосами вдоль бока. Гоняет стаи малька в толще водохранилищ.',
  'fish.longnose_gar': 'длиннорылый панцирник',
  'fish.longnose_gar_look':
    'Длинное тело в костяной броне и узкое зубастое рыло вдвое длиннее головы. Висит у поверхности.',
  'fish.alligator_gar': 'миссисипский панцирник',
  'fish.alligator_gar_look':
    'Гигант в панцире из ромбовидных пластин, с короткой крокодильей пастью в два ряда зубов.',
  'fish.lake_sturgeon': 'озёрный осётр',
  'fish.lake_sturgeon_look':
    'Тёмный осётр с тупым рылом и крупными жучками. Кормится на дне глубоких озёр и рек.',
  'fish.white_sturgeon': 'белый осётр',
  'fish.white_sturgeon_look':
    'Самая крупная рыба Северной Америки: серо-белая, с четырьмя усиками у широкого рта.',

  // ── Тропики и Южное полушарие ───────────────────────────────────────────
  'fish.golden_mahseer': 'золотой махсир',
  'fish.golden_mahseer_look':
    'Золотая чешуя с ладонь, толстые губы и мощный хвост. Стоит в бурных ямах гималайских рек.',
  'fish.rohu': 'роху',
  'fish.rohu_look':
    'Серебристо-голубой, с выпуклым лбом и направленным вниз ртом. Кормится в толще тёплых рек.',
  'fish.siamese_carp': 'сиамский карп',
  'fish.siamese_carp_look':
    'Огромный высокотелый карп с непомерно большой головой и крупной чешуёй. Ходит по дну Меконга.',
  'fish.goonch': 'гунч',
  'fish.goonch_look':
    'Приплюснутый сом с широкой пастью и длинными усами, бок в тёмных пятнах. Держится за камнями.',
  'fish.wallago': 'валлаго',
  'fish.wallago_look':
    'Плоский серебристый сом с огромной пастью до затылка и двумя усами. Стоит в засаде под берегом.',
  'fish.mekong_catfish': 'меконгский сом',
  'fish.mekong_catfish_look':
    'Гигант без усов и почти без зубов, серо-стальной, с маленькими глазами. Ходит в толще Меконга.',
  'fish.giant_pangasius': 'сиамский пангасиус',
  'fish.giant_pangasius_look':
    'Тёмный пангасиус с нитевидными вытянутыми плавниками и высоким спинным гребнем.',
  'fish.redtail_catfish': 'краснохвостый сом',
  'fish.redtail_catfish_look':
    'Чёрная спина, белая полоса вдоль бока и ярко-красный хвост. Выходит на охоту в темноте.',
  'fish.giant_snakehead': 'гигантский змееголов',
  'fish.giant_snakehead_look':
    'Змеиная голова, длинный спинной плавник, бок в чёрных полосах. Стережёт красный выводок мальков.',
  'fish.peacock_bass': 'павлиний окунь',
  'fish.peacock_bass_look':
    'Золотисто-зелёный, с тремя тёмными перевязями и глазком на хвосте. Бьёт малька у коряг.',
  'fish.dorado': 'золотой дорадо',
  'fish.dorado_look':
    'Золотая чешуя, красный хвост, тупая голова с костяной пастью. Прыгает свечкой, как лосось.',
  'fish.traira': 'траира',
  'fish.traira_look':
    'Вальковатая, бурая, с широкой зубастой пастью. Лежит в засаде среди травы мелких заводей.',
  'fish.tambaqui': 'тамбаки',
  'fish.tambaqui_look':
    'Высокий, чёрно-серый, с зубами как у человека — дробит орехи и семена, падающие в воду.',
  'fish.tigerfish': 'тигровая рыба',
  'fish.tigerfish_look':
    'Серебряный бок в продольных полосах и клыки, торчащие наружу при закрытой пасти.',
  'fish.goliath_tiger': 'голиафовый тигр',
  'fish.goliath_tiger_look':
    'Тигровая рыба Конго ростом с человека: тридцать два клыка и красные плавники.',
  'fish.nile_perch': 'нильский окунь',
  'fish.nile_perch_look':
    'Серебряно-оливковый, с горбатой спиной и жёлтым глазом. Стоит у глубоких бровок и скал.',
  'fish.barramundi': 'барамунди',
  'fish.barramundi_look':
    'Серебряный, с вогнутым лбом и высоким хвостом; глаз светится розовым. Ходит по устьям и рекам.',
  'fish.murray_cod': 'муррейская треска',
  'fish.murray_cod_look':
    'Тяжёлая рыба в зелёных мраморных разводах, с широкой пастью. Живёт под корягами десятилетиями.',
  'fish.arapaima': 'арапайма',
  'fish.arapaima_look':
    'Гигант в крупной красной чешуе, дышит воздухом и с шумом всплывает подышать раз в четверть часа.',
};
